import useChartDateFormatter from '@Dashboard/RiskUser/useChartDateFormatter';
import { TimeRangeEnum } from '@Dashboard/TimeRangeSelector';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { useMemo } from 'react';
import { ECharts, EChartsProps } from 'src/ECharts';
import {
  dashboardAtRiskUserTrendsLineSeries,
  dashboardTimerangeXData,
} from 'src/ECharts/utils';

export interface RiskUserTrendsProps extends EChartsProps {
  data: Record<string, Record<string, { total: number }>>;
  interval: string;
}

export const RiskUserTrends = (props: RiskUserTrendsProps) => {
  const { data: _data, interval, ...echartsProps } = props;
  const timeModel = useUtcOffsetStore();
  const { format } = useChartDateFormatter();

  const data = useMemo(() => _data ?? {}, [_data]);

  const series = useMemo(() => {
    const categories = Object.entries(data).map(([risk]) => risk);
    return categories.map((category) =>
      dashboardAtRiskUserTrendsLineSeries({
        data,
        category,
      })
    );
  }, [data]);

  return (
    <ECharts
      series={series}
      xAxis={{
        data: dashboardTimerangeXData(
          data[Object.keys(data)[0]],
          timeModel.offset
        ).map((timestamp) =>
          format({
            timestamp,
            interval: interval as TimeRangeEnum,
          })
        ),
        axisLabel: {
          rotate: 0,
        },
      }}
      grid={{ top: 20, right: 300, bottom: 40, left: 40 }}
      legend={{
        top: 'middle',
        orient: 'vertical',
        align: 'left',
        right: 20,
        textStyle: { overflow: 'truncate', width: 225, align: 'left' },
      }}
      height="169px"
      {...echartsProps}
    />
  );
};
